define('../app/fukit/view/block/note.footer.message.view',['require','exports','module','../../helpers/formatter','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var Formatter = require('../../helpers/formatter'),
      UIKit     = require('uikit/uikit');


  var NoteFooterMessageView = UIKit.ItemView.extend({
    template: function() {
      return "Created by <ui name='createdByView'/> on <ui name='createdOnView'/>";
    },

    internalViewBindings: {
      createdByView: {
        model: 'model'
      },
      createdOnView: {
        model: 'model'
      }
    },

    internalViewOptions: {
      createdByView: function() {
        return {
          type: UIKit.Text,
          bindings: {
            text: this.getModelAttributeFromMap('createdByName')
          },
        }
      },
      createdOnView: function() {
        return {
          type: UIKit.Text,
          bindings: {
            text: this.getModelAttributeFromMap('createdOn')
          },
          formatter: Formatter.date('L LT')
        }
      }
    },

    getModelAttributeFromMap: function(attribute) {
      var attributeMap = this.getOption('attributeMap');
      if (!attributeMap) {
        return '';
      }
      else {
        return attributeMap[attribute] || '';
      }
    }
  });

  module.exports = NoteFooterMessageView;
});

